// This template generates one route per color, at ${projectName}/${color}. Navigating to that
// route, either programmatically or by manual navigation, will open an aframe scene with a cube
// of the specified color. A navigation element is also populated with all of these colors on
// the app's home page.

const COLORS = {
  purple: "#7611B6",
  yellow: "#FFC828",
  red: "#DD0065",
  green: "#00EDAF",
  black: "#000000",
  white: "#FFFFFF",
}

export default COLORS
